import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import React, { useState } from 'react';
import { backendRequest } from "@/stores/thunks";
import { useDispatch, useSelector } from "react-redux";
import i18n from 'i18n-js';
import FloatingLabelInput from "@/components/basic/FloatingLabelInput";
import { switchScreen } from '@/hooks/navigate';
import BasicButton from "@/components/basic/BasicButton";
import CancelButton from "@/components/basic/CancelButton";
import { Alert } from "react-native";

export default function ModalAddContactEmail({ navigation, route }) {
    const user = useSelector((state) => state.user)
    const [email, setEmail] = useState('')
    const dispatch = useDispatch()

    return (
        <View className="flex-1 bg-[#00000050] justify-center">
            <VStack space='md' className="m-3 bg-secondary-50 px-4 py-5 rounded-[5px]">
                <Text className="font-[400] text-2xl leading-2xl text-secondary-900">{i18n.t('addContact.emailAddress')}</Text>
                <Text className="font-[400] text-xl leading-2xl text-secondary-900">{i18n.t('addContact.text')}</Text>
                <View className="w-[100%]">
                    <FloatingLabelInput autoCapitalize='none' label={i18n.t('addContact.email')} value={email} placeholder={i18n.t('addContact.email')} onChangeText={setEmail} />
                </View>
                <VStack space='sm' className="pt-3 w-[100%]">
                    <BasicButton bg={email ? 'bg-primary-900' : 'bg-primary-400'} disabled={!email} onPress={() => {
                        if (email.trim().toLowerCase() != user.mail) {
                            dispatch(backendRequest('REQUEST_CONTACT_INLINE', '/contact/request', {
                                mail: email.trim().toLowerCase(),
                            }, 'POST', false)).then(contacts => {
                                // console.log('RESULT', contacts)
                                if (contacts.result) {
                                    switchScreen(navigation, 'ModalRequestSent', { title: 'addContact.requestSent', text: 'addContact.requestSentText', back: 'ContactManagement' })
                                } else {
                                    switchScreen(navigation, 'ModalRequestSent', { title: 'addContact.requestFail', text: 'addContact.requestFailText', options: { user: email } })
                                }
                            })
                        } else {
                            Alert.alert(i18n.t('global.warning'), i18n.t('global.ownMail'), [{ text: "OK", onPress: () => { }, }])
                        }
                    }} text={i18n.t('addContact.send')} />
                    <CancelButton onPress={() => { switchScreen(navigation, 'BACK') }} text={i18n.t('addContact.cancel')} />
                </VStack>
            </VStack>
        </View>
    );
}
